// src/store/slices/questionnaireSlice.ts
// 📋 Данные анкеты

import type { StateCreator } from 'zustand';

// ========== SLICE STATE ==========

export interface QuestionnaireState {
  age: number | null;
  skin_type: 'normal' | 'oily' | 'dry' | 'combination' | null;
  is_sensitive: boolean;
  is_sick: boolean;
  use_retinol_before: boolean;
  last_use_retinol: string | null;
  plan_start_use_retinol: string | null;
  need_notifications: boolean;
  completedAt: string | null;
}

export interface QuestionnaireSlice {
  // State
  questionnaire: QuestionnaireState | null;
  contraindication: boolean;

  // Actions
  setQuestionnaire: (data: QuestionnaireState) => void;
  resetQuestionnaire: () => void;
}

// ========== INITIAL STATE ==========

const initialQuestionnaireState = {
  questionnaire: null,
  contraindication: false,
};

// ========== SLICE CREATOR ==========

export const createQuestionnaireSlice: StateCreator<
  QuestionnaireSlice,
[],
[],
  QuestionnaireSlice
> = (set) => ({
  ...initialQuestionnaireState,

  setQuestionnaire: (data) => {
    set({
      questionnaire: data,
      contraindication: data.is_sick,
    });
    if (process.env.NODE_ENV === 'development') {
      console.log('✅ Анкета сохранена:', {
        age: data.age,
        skinType: data.skin_type,
        sensitive: data.is_sensitive,
        sick: data.is_sick,
      });
    }
  },

  resetQuestionnaire: () => {
    set(initialQuestionnaireState);
  },
});